import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EligibilityConditionSchema = withDefaults({
  type: 'eligibility-condition',
  fields: [
    { kind: 'attribute', name: 'name' },
    { kind: 'attribute', name: 'label' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
  ],
});

export default EligibilityConditionSchema;
